var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9H31V26.3333H24.5V9Z",
    fill: "#329F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4316 48H11.0683L7.16663 27.4166H48.3333L44.4316 48Z",
    fill: "#7CCC90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.9166H50.5V28.5H5V20.9166Z",
    fill: "#7CCC90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5834 30.6666H29.9167V43.6666H25.5834V30.6666Z",
    fill: "#56B16C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9166 30.6666H21.25V43.6666H16.9166V30.6666Z",
    fill: "#56B16C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 30.6666H38.5833V43.6666H34.25V30.6666Z",
    fill: "#56B16C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20.9166H31V25.25H24.5V20.9166Z",
    fill: "#56B16C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.c4ae3edc28e7e6463e3048a1bcad4559.svg";
export { ForwardRef as ReactComponent };